module.exports = __webpack_public_path__ + "img/110091.9a96d40e.png";